import { render } from "./NotQualifedPage.vue?vue&type=template&id=c154f430&scoped=true"
import script from "./NotQualifedPage.vue?vue&type=script&lang=js"
export * from "./NotQualifedPage.vue?vue&type=script&lang=js"

import "./NotQualifedPage.vue?vue&type=style&index=0&id=c154f430&lang=css"
import "./NotQualifedPage.vue?vue&type=style&index=1&id=c154f430&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c154f430"]])

export default __exports__